export default __webpack_public_path__ + "static/media/Accreditations.09b1d3e9.jpg";